import React from 'react';

import { observable, computed, autorun, reaction, runInAction, untracked, action } from 'mobx';
import moment from 'moment';

import { TIME_UNIT_ID, TIME_UNIT_DURATION } from '../model/const';
import confirmationDialog from '../model/ConfirmationDialog';
import { roundTime, ceilTime, floorTime, expandIntervalEnd, shiftIntervalAfter } from '../utils';

export class VOfferDetails {

  /*@computed get objectDetailsData() {
    return this.rentalObject.data;
  }*/

  @observable ruleExceptionsClosed = false;

  @action.bound closeRuleExceptions() {
    this.ruleExceptionsClosed = true;
  }

  @computed get bestOfferItems() {
    return this.bestOffers.bestOfferItems;
  }

  @computed get startDate() {
    if (moment(this.offerDetailsForm.values.startDate).isBefore(this.offerDetailsForm.values.endDate)) {
      return this.offerDetailsForm.values.startDate;
    } else {
      return this.offerDetailsForm.values.endDate;
    }
  }

  @computed get endDate() {
    if (moment(this.offerDetailsForm.values.startDate).isBefore(this.offerDetailsForm.values.endDate)) {
      return this.offerDetailsForm.values.endDate;
    } else {
      return this.offerDetailsForm.values.startDate;
    }
  }

  @computed get displayElements() {
    let tuId = this.organization.refAllotmentTimeUnitId;
    //tuId = TIME_UNIT_ID.QUARTER_HOUR;
    switch (tuId) {
      case TIME_UNIT_ID.WEEK:
        return { date: true }
      case TIME_UNIT_ID.DAY:
        return { date: true }
      case TIME_UNIT_ID.NIGHT:
        return { date: true }
      case TIME_UNIT_ID.HOUR:
        return { date: true, hours: true, plus: { minutes: 60 }, minus: { minutes: 60 } }
      case TIME_UNIT_ID.QUARTER_HOUR:
        return { date: true, hours: true, minutes: true, plus: { minutes: 15 }, minus: { minutes: 15 } }
      default:
        return {}
    }
  }

  @computed get isNightGranularity() {
    return (this.organization.refAllotmentTimeUnitId === TIME_UNIT_ID.NIGHT);
  }

  /*
    switch(tuId) {
      case TIME_UNIT_ID.WEEK:
      case TIME_UNIT_ID.DAY:
      case TIME_UNIT_ID.NIGHT:
        this.setCalendarViewType('month');
        return;
      case TIME_UNIT_ID.HOUR:
      case TIME_UNIT_ID.QUARTER_HOUR:
      */

  constructor(flasher, onNewTransactionId, searchForm,
    rentalObject, bestOffers, offerDetailsForm, rentalTransaction, authentication, aggAccessories,
    allotmentDetails, rentalAccessoryApi, businessUnit, organization, vBookingWizard, personalDataForm, personalAddressForms) {
    this.flasher = flasher
    this.onNewTransactionId = onNewTransactionId;
    this.searchForm = searchForm;
    this.rentalObject = rentalObject;
    this.bestOffers = bestOffers;
    this.offerDetailsForm = offerDetailsForm;
    this.rentalTransaction = rentalTransaction;
    this.authentication = authentication;
    this.aggAccessories = aggAccessories;
    this.allotmentDetails = allotmentDetails;
    this.rentalAccessoryApi = rentalAccessoryApi;
    this.businessUnit = businessUnit;
    this.organization = organization;
    this.vBookingWizard = vBookingWizard;
    this.personalDataForm = personalDataForm;
    this.personalAddressForms = personalAddressForms;

    this.reactions = [];
    this.trxId = null;
  }

  @action.bound goSelection() {
    this.allotmentDetails.goSelection({ start: moment(this.startDate), end: moment(this.endDate) });
  }

  @action.bound changeViewType() {
    this.allotmentDetails.changeViewType();
    this.goSelection();
  }

  @action.bound setSelection({ start, end }) {
    this.offerDetailsForm.handleStartEndChange({
      from: start,
      to: end,
    })
  }

  async updateOffer(isTransactionJustStarted) {
    if (this.updateInProgress) {
      this.nextUpdatePending = true;
      return;
    }
    do {
      this.updateInProgress = true;
      this.nextUpdatePending = false;
      try {
        if (
          this.startDate !== undefined &&
          this.endDate !== undefined &&
          this.orgId !== undefined &&
          this.objId !== undefined
        ) {
          let startDate;
          let endDate;
          startDate = floorTime(this.startDate, this.orgTimeAtomSecs, this.isNightGranularity);
          endDate = ceilTime(this.endDate, this.orgTimeAtomSecs, this.isNightGranularity);
          if (this.orgMinBookingLength) {
            ({ start: startDate, end: endDate } = expandIntervalEnd({ start: startDate, end: endDate }, this.orgMinBookingLength));
          }
          this.flasher.setOther('Loading.');
          this.offerDetailsForm.initNewValuesFromCurrentValues();
          console.log(`Obtaining best offers for [${moment(startDate).format('YYYY-MM-DD HH:mm')}, ${moment(endDate).format('YYYY-MM-DD HH:mm')}]`)
          await this.bestOffers.cFetch({
            startDate: startDate,
            endDate: endDate,
            organizationId: this.orgId,
            objectId: this.objId,
            timeUnit: this.searchForm.timeUnit,
            oldStartDate: undefined,
            oldEndDate: undefined,
          })

          if (this.bestOffers.ruleExceptions && this.bestOffers.ruleExceptions.length > 0) {
            let ruleExceptions = [...this.bestOffers.ruleExceptions];
            if (isTransactionJustStarted) {
              console.log('Transaction just started. Omitting booking exceptions with less importance.');
              ruleExceptions = ruleExceptions.filter(o => o.severity === 0);
            }
            if (ruleExceptions.length > 0) {
              const message =
                this.bestOffers.ruleExceptions.map(exc => {
                  return <div className="confirmation-message-item">{exc.message}</div>
                })
              await confirmationDialog.confirm(message, [{ label: "OK", value: "true", className: "button-ok" }]);
            } else {
              console.log('Rule exceptions are not important for now.')
            }
          }

          const inTrxAcc = this.aggAccessories.joinedListing.filter(o => o.inTransaction);
          const inTrxCounts = inTrxAcc.map(o => o.quantity);


          this.flasher.setOther('Loading.');
          await this.rentalAccessoryApi.setAccessoryQuantities({
            orgId: this.orgId,
            trxId: this.trxId,
            items: inTrxAcc.map(o => ({ item: o, quantity: 0 }))
          });

          this.flasher.setOther('Loading.');
          await this.rentalTransaction.deleteOffer({
            orgId: this.orgId,
            trxId: this.trxId,
            deleter: this.rentalTransaction.offerDeleter(
              this.rentalTransaction.mainObjectOffers.map(o => o.deleterItem()))
          });

          if (this.bestOffers.bestOfferItems.length > 0) {
            const bOffersUpdater = this.bestOffers.transactionUpdater;
            this.flasher.setOther('Loading.');
            await this.rentalTransaction.addOffer({
              orgId: this.orgId,
              trxId: this.trxId,
              updater: bOffersUpdater,
            });


            /*
              Bug here? inTrxAcc might have more offers when changing time interval to span multiple seasons?
            */
            let changerItems = [];
            for (let i = 0; i < inTrxAcc.length; i++) {
              let item = this.aggAccessories.joinedListing.find(o => {
                return o.pk === inTrxAcc[i].pk
              });
              changerItems.push({ item, quantity: inTrxCounts[i] });
            }
            console.log('A')
            //debugger
            await this.rentalAccessoryApi.addAccessories({
              orgId: this.orgId,
              trxId: this.trxId,
              items: changerItems,
            });
            console.log('B')

            let obligatoryAccToAdd = this.aggAccessories.joinedListing
              .filter(o => !o.inTransaction)
              .filter(o => o.isObligatory);
            //debugger
            await this.rentalAccessoryApi.addAccessories({
              orgId: this.orgId,
              trxId: this.trxId,
              items: obligatoryAccToAdd.map(o => {
                return {
                  item: o,
                  quantity: 1,
                }
              }),
            });


          } else {
          }
        }
      }
      catch (e) {
        this.flasher.handleError(e);
      }
      finally {
        this.updateInProgress = false;
        this.flasher.setOther();
      }
    } while (this.nextUpdatePending);
    if (this.rentalTransaction.rentingStartDate &&
      this.rentalTransaction.rentingEndDate &&
      moment(this.rentalTransaction.rentingStartDate).isValid() &&
      moment(this.rentalTransaction.rentingEndDate).isValid()
    ) {
      this.offerDetailsForm.reset({
        startDate: moment(this.rentalTransaction.rentingStartDate).toISOString(),
        endDate: moment(this.rentalTransaction.rentingEndDate).toISOString(),
      });
      this.offerDetailsForm.initNewValuesFromCurrentValues();
    }
  }

  formCallbackRegistered = false;

  async startOrUpdate({ orgId, objId, trxId, timeUnitId, duration, startDate, endDate }, router) {
    this.orgId = orgId;
    this.objId = objId;
    this.trxId = trxId;
    this.allotmentDetails.orgId = orgId;
    this.allotmentDetails.objId = objId;
    this.allotmentDetails.loadedForStart = false;
    let isTransactionJustStarted = false;
    try {
      this.flasher.setOther("Loading.");
      /*const timeUnitId = this.searchForm.timeUnit;
      const duration = this.searchForm.duration;
      const startDate = this.searchForm.startDate;
      const endDate = this.searchForm.endDate; */
      if (window.sessionStorage.getItem('canInitTxn') != 'true') {
        console.error('Booking cannot be initiated.');
        window.location = window.location.pathname;
        //throw new Error("Cannot initiate Transaction.");
      }
      if (!startDate) {
        startDate = moment().toISOString();
        window.sessionStorage.setItem('bwStartDate', startDate);
      }
      if (!endDate) {
        endDate = startDate;
        window.sessionStorage.setItem('bwEndDate', endDate);
      }
      this.offerDetailsForm.reset({ startDate, endDate });
      this.offerDetailsForm.initNewValuesFromCurrentValues();

      await this.organization.cFetch({ orgId })

      this.orgTimeAtomSecs = TIME_UNIT_DURATION[this.organization.refAllotmentTimeUnitId];
      if (!this.orgTimeAtomSecs) {
        console.error('No length for this organization atom.');
        this.orgTimeAtomSecs = 15 * 60;
      }

      let shortest
      let timeUnits = [...this.organization.timeUnits];
      timeUnits.sort((a, b) => {
        return a.timeLengthSec - b.timeLengthSec
      });
      this.orgMinBookingLength = timeUnits[0].timeLengthSec

      console.log('Minimum booking length (seconds):', this.orgMinBookingLength)

      startDate = floorTime(startDate, this.orgTimeAtomSecs, this.isNightGranularity);
      endDate = ceilTime(endDate, this.orgTimeAtomSecs, this.isNightGranularity);
      if (this.orgMinBookingLength) {
        ({ start: startDate, end: endDate } = expandIntervalEnd({ start: startDate, end: endDate }, this.orgMinBookingLength));
      }
      //({start: startDate, end: endDate} = shiftIntervalAfter({start: startDate, end: endDate}, moment()));


      if (!trxId) {
        window.sessionStorage.removeItem('servicesPassed');
        window.sessionStorage.removeItem('accessoriesPassed');
        this.vBookingWizard.resetVisitedSteps();
        this.vBookingWizard.setVisitedStep(1);
        this.personalDataForm.reset({
          salutation: '',
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          oldPassword: '',
          password1: '',
          password2: '',
        });
        this.personalAddressForms.forEach(o => {
          o.reset({
            street: '',
            addition: '',
            postalCode: '',
            city: '',
            country: '',
          })
        });
        await this.rentalTransaction.begin({ orgId, duration, startDate, objId, timeUnit: timeUnitId });
        this.trxId = trxId = this.rentalTransaction.id;
        //#411 txn created successfully, remove the flag

        if (this.authentication.loggedIn) {
          await this.rentalTransaction.setCurrentUserAsLessee({
            orgid: this.orgId,
            trxId: this.trxId,
          });
        }

        window.sessionStorage.removeItem('canInitTxn');
        router.setParams({ bwTrxId: trxId });

        isTransactionJustStarted = true;
      } else {
        await this.rentalTransaction.cFetch({ orgId, trxId, });

        // TODO: overwrite startDate and endDate by those from the transaction ????????
      }
      this.objId = objId = this.rentalTransaction.refRentalObjectId;
      await Promise.all([
        this.rentalObject.cFetch({ orgId, objId, }),
      ]);
      await this.businessUnit.cFetch({
        businessUnitId: this.rentalObject.businessUnitId,
      });



      //this.allotmentDetails.setCalendarViewTypeByTUId(this.organization.refAllotmentTimeUnitId);
      this.allotmentDetails.setCalendarViewTypeByTimespan(startDate, endDate);
      this.allotmentDetails.setCalendarDefaultDate((this.startDate ? moment(this.startDate) : moment()));

      await this.allotmentDetails.loadDataForView();
    }
    catch (e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther();
    }

    this.stopReactions();
    if (!this.formCallbackRegistered) {
      this.formCallbackRegistered = true;
      this.offerDetailsForm.onValuesChanged(() => {
        console.log('OfferDetailsForm values changed.')
        this.takeStartAndEndDatetime(false);
      })
    }
    this.takeStartAndEndDatetime(isTransactionJustStarted);
  }

  @action.bound takeStartAndEndDatetime(isTransactionJustStarted) {
    let startDate = this.startDate;
    let endDate = this.endDate;

    console.log(`Reacting on interval [${moment(startDate).format('YYYY-MM-DD HH:mm')}, ${moment(endDate).format('YYYY-MM-DD HH:mm')}]`)

    let newStartDate = floorTime(startDate, this.orgTimeAtomSecs, this.isNightGranularity);
    let newEndDate = ceilTime(endDate, this.orgTimeAtomSecs, this.isNightGranularity);
    console.log(`After both sides expansion to atom mul (if needed): [${moment(newStartDate).format('YYYY-MM-DD HH:mm')}, ${moment(newEndDate).format('YYYY-MM-DD HH:mm')}]`)
    if (this.orgMinBookingLength) {
      ({ start: newStartDate, end: newEndDate } = expandIntervalEnd({ start: newStartDate, end: newEndDate }, this.orgMinBookingLength));
      console.log(`After end expansion to lessor min booking time (if needed): [${moment(newStartDate).format('YYYY-MM-DD HH:mm')}, ${moment(newEndDate).format('YYYY-MM-DD HH:mm')}]`)
    }
    /*if(
      !moment(startDate).isSame(moment(newStartDate)) || 
      !moment(endDate).isSame(moment(newEndDate))) {   
      this.offerDetailsForm.reset({
        startDate: newStartDate,
        endDate: newEndDate,
      });
      this.offerDetailsForm.initNewValuesFromCurrentValues();
      console.log('Adjusted start and end dates.')
      //return
    }*/

    window.sessionStorage.setItem('bwStartDate', startDate);
    window.sessionStorage.setItem('bwEndDate', endDate);
    this.updateOffer(isTransactionJustStarted);
    isTransactionJustStarted = false;
  }

  @action.bound stop() {
    this.searchForm.stop();
    this.stopReactions();
  }

  @action.bound stopReactions() {
    this.reactions.forEach(ar => ar());
    this.reactions = [];
  }

} 


// WEBPACK FOOTER //
// ./src/view/VOfferDetails.js